var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.908 4.488c-.08-.333-.399-.665-.797-.665l-2.95-.416L6.806.582C6.646.249 6.328 0 6.009 0c-.399 0-.718.25-.877.582L3.777 3.407l-2.95.416c-.399.083-.638.332-.797.665-.08.332 0 .748.239.997l2.152 2.16-.478 3.159c-.08.415.08.748.399.997.319.25.717.25 1.036.083l2.71-1.496 2.71 1.496c.16.083.32.083.48.083.159 0 .398-.083.557-.166.32-.25.479-.582.399-.997l-.478-3.075 2.152-2.16c.08-.333.16-.666 0-1.081z",
    fill: "#F2B718"
  })));
}
export default SvgRatingS;